import Vue from '@/index.js'
import page from '@/mixins/page'
import { gmapApi } from 'vue2-google-maps'

// Подключение стилей только для этой страницы
require('./page.scss')

const components = {
  Slider: () => import('@/components/index/slider.vue'),
  NestedSlider: () => import('@/components/index/nested-slider.vue'),
  Slide: () => import('@/components/index/slide.vue'),
}

export default new Vue({
  mixins: [page],
  el: '#app',
  data () {
    return {
      slideNum: 1,
      digit: true,
      message: ''
    }
  },
  components,
  methods: {
    async submitCall ($event) {

      const form = $event.target
      const action = form.action
      const formData = new FormData(form)
      const { data } = await this.$axios.post(action, formData)
      this.message = data.message
      if (data.result === true) {
      } else {
      }
    }
  },
  mounted(){
  },
})
